import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ITalentMember } from 'shared/interfaces/IProfile';

export interface AppState {
  headerTitle: string;
  showHeaderBack: boolean;
  guardian: {
    isGuardian: boolean;
    guardianUI: boolean;
    members: ITalentMember[];
  };
}

const initialState: AppState = {
  headerTitle: '',
  showHeaderBack: false,
  guardian: {
    isGuardian: false,
    guardianUI: false,
    members: [],
  },
};

export const appSlicer = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setHeaderTitle: (state: AppState, action: PayloadAction<{ headerTitle: string }>) => {
      const { headerTitle } = action.payload;
      state.headerTitle = headerTitle;
    },
    setShowHeaderBack: (state: AppState, action: PayloadAction<{ showHeaderBack: boolean }>) => {
      const { showHeaderBack } = action.payload;
      state.showHeaderBack = showHeaderBack;
    },
    setGuardian: (
      state: AppState,
      action: PayloadAction<{ guardianUI?: boolean; isGuardian?: boolean; members?: ITalentMember[] }>,
    ) => {
      const { guardianUI, isGuardian, members } = action.payload;
      state.guardian.guardianUI = guardianUI || state.guardian.guardianUI;
      state.guardian.isGuardian = isGuardian || state.guardian.isGuardian;
      state.guardian.members = members || state.guardian.members;
    },
  },
});

export const selectAppState = (state: RootState) => state.app;
export const { setHeaderTitle, setShowHeaderBack, setGuardian } = appSlicer.actions;

export default appSlicer.reducer;
